<template>
    <Loader v-if="loader"/>
    <Header/>
    <main class="p-3 p-md-2">
        <router-view/>
    </main>
</template>

<script>
import $ from 'jquery'
import { mapState, mapGetters } from 'vuex'
import Loader from '@/components/Loader.vue'
import Header from './components/Header.vue'
export default {
    name: 'f1cnomz7iH2QL3ow6pjqJ',
    components: {
        Loader,
        Header
    },
    computed: {
        ...mapState(['config', 'loader']),
        ...mapGetters(['ApiKey'])
    },
    methods: {
        setFavicons(favImg) {
            let headTitle = document.querySelector('head')
            let setFavicon = document.createElement('link')
            setFavicon.setAttribute('rel', 'icon')
            setFavicon.setAttribute('href', favImg)
            headTitle.appendChild(setFavicon)
        }
    },
    created() {
        document.title = this.config.tenant
        this.setFavicons(`/${this.ApiKey}.ico`)
        $('body').addClass(`${this.config.env}`)
        this.$store.dispatch('autoSetCredentials')
    }
}
</script>

<style lang="scss">
    @import '@/style/ui/f1cnomz7iH2QL3ow6pjqJ.scss';
</style>